import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the measurementCreate state domain
 */

const selectMeasurementCreateDomain = (state) =>
  state.get("measurementCreate", initialState)

/**
 * Other specific selectors
 */
//  GET DIVISION
export const makeSelectIsLoadingDivisions = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("isLoadingDivisions")
  )

export const makeSelectDivisions = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("divisions")
  )

//  GET DIVISION
export const makeSelectIsLoadingDescendents = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("isLoadingDescendents")
  )

export const makeSelectDescendents = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("descendents")
  )

//  POST LOGO
export const makeSelectIsLoadingLogoUrl = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("isLoadingLogoUrl")
  )

export const makeSelectLogoUrl = () =>
  createSelector(selectMeasurementCreateDomain, (state) => state.get("logoUrl"))

// IMAGE LOGO
export const makeSelectIsLoadingImageUrl = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("isLoadingImageUrl")
  )

export const makeSelectImageUrl = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("imageUrl")
  )

// NAME MEASUREMENT
export const makeSelectNameMeasurement = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("nameMeasurement")
  )

// FIRST STEP DATA
export const makeSelectFirstStepData = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("firstStepData")
  )
export const makeSelectIsLoadingFirstStepData = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("isLoadingFirstStepData")
  )

// mail step
export const makeSelectMailStepData = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("mailStepData")
  )

export const makeSelectIsLoadingMailStepData = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("isLoadingMailStepData")
  )

// recipients step
export const makeSelectRecipientsStepData = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("recipientsStepData")
  )

export const makeSelectIsLoadingRecipientsStepData = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("isLoadingRecipientsStepData")
  )

// datacheck step
export const makeSelectDataCheckStepData = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("dataCheckStepData")
  )

export const makeSelectIsLoadingDataCheckStepData = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("isLoadingDataCheckStepData")
  )

// preview step
export const makeSelectPreviewStepData = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("previewStepData")
  )

export const makeSelectIsLoadingPreviewStepData = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("isLoadingPreviewStepData")
  )

// schedule step
export const makeSelectScheduleStepData = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("scheduleStepData")
  )

export const makeSelectIsLoadingScheduleStepData = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("isLoadingScheduleStepData")
  )

// complete step
export const makeSelectCompleteStepData = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("completeStepData")
  )

export const makeSelectIsLoadingCompleteStepData = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("isLoadingCompleteStepData")
  )

export const makeSelectForceSaveData = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("forceSaveData")
  )

export const makeSelectIsLoadingForceSaveData = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("isLoadingForceSaveData")
  )

export const makeSelectEmployeesBySegments = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("recipientsSegments")
  )
export const makeSelectIsLoadingEmployeesBySegments = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("isLoadingRecipientsSegments")
  )
// SECOND STEP DATA
export const makeSelectSecondStepData = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("secondStepData")
  )
export const makeSelectIsLoadingSecondStepData = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("isLoadingSecondStepData")
  )

// FOURTH STEP DATA
export const makeSelectFourthStepData = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("fourthStepData")
  )
export const makeSelectIsLoadingFourthStepData = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("isLoadingFourthStepData")
  )

// GET LEADERS
export const makeSelectGetLeaders = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("getLeaders")
  )
export const makeSelectIsLoadingGetLeaders = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("isLoadingGetLeaders")
  )

// GET SURVEYS TYPE
export const makeSelectIsLoadingSurveysType = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("isLoadingSurveysType")
  )

export const makeSelectSurveysType = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("surveysType")
  )

export const makeSelectGetMeasure = () =>
  createSelector(selectMeasurementCreateDomain, (state) => state.get("measure"))

export const makeSelectIsLoadingMeasure = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("isLoadingMeasure")
  )

export const makeSelectIsLoadingUpdateMeasure = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("isLoadingUpdateMeasure")
  )

export const makeSelectSegments = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("segments")
  )

export const makeSelectIsLoadingSegments = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("isLoadingSegments")
  )

export const makeSelectSurveyTypes = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("surveyTypes")
  )

export const makeSelectIsLoadingSurveyTypes = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("isLoadingSurveyTypes")
  )

export const makeSelectScopeTypes = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("scopeTypes")
  )

export const makeSelectIsLoadingScopeTypes = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("isLoadingScopeTypes")
  )

export const makeSelectOrganizationSurveys = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("organizationSurveys")
  )

export const makeSelectIsLoadingOrganizationSurveys = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("isLoadingOrganizationSurveys")
  )

export const makeSelectSegmentsSurveys = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("segmentsSurveys")
  )

export const makeSelectIsLoadingSegmentsSurveys = () =>
  createSelector(selectMeasurementCreateDomain, (state) =>
    state.get("isLoadingSegmentsSurveys")
  )

/**
 * Default selector used by MeasurementCreate
 */

const makeSelectMeasurementCreate = () =>
  createSelector(selectMeasurementCreateDomain, (substate) => substate.toJS())

export default makeSelectMeasurementCreate
export { selectMeasurementCreateDomain }
